module.exports = __webpack_public_path__ + "static/media/Events.ba656a63.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/buttons/Events.PNG
// module id = 37
// module chunks = 0